import script from "./cookies-consent.vue?vue&type=script&setup=true&lang=js"
export * from "./cookies-consent.vue?vue&type=script&setup=true&lang=js"

import "./cookies-consent.vue?vue&type=style&index=0&id=557c8e90&lang=scss"

const __exports__ = script;

export default __exports__